// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__iDFIv","spin":"Loader_spin__E4RJ0"};